import React from 'react';
import { Menu } from 'react-contexify';
import { createPortal } from 'react-dom';
import 'react-contexify/dist/ReactContexify.css';
import CloseAllTabsMenuItem from './CloseAllTabsMenuItem';

// api docs: https://fkhadra.github.io/react-contexify/quick-start

export const MENU_ID = 'nav-tab-menu';

function Portal({ children }) {
  const portal: any = document.querySelector('#portals') || document.querySelector('body');
  return createPortal(children, portal);
}

function ContextMenu() {
  return (
    <div>
      <Portal>
        <Menu id={MENU_ID}>
          <CloseAllTabsMenuItem />
        </Menu>
      </Portal>
    </div>
  );
}

export default ContextMenu;
